const VIDEO_STREAM_STATE = {
  INITIALIZING: 'INITIALIZING',
  WAITING_TO_CONNECT: 'WAITING_TO_CONNECT',
  CONNECTING: 'CONNECTING',
  WAITING_FOR_VIDEO: 'WAITING_FOR_VIDEO',
  CONNECTED: 'CONNECTED',
  DISCONECTED: 'DISCONECTED',
  ERROR_MICROPHONE_ACCESS: 'ERROR_MICROPHONE_ACCESS'
};

export {
  VIDEO_STREAM_STATE
}
